import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CmsService, Product, ProductScope, ProductService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CustomOutletGridData } from './custom-outlet-grid.model';

@Component({
  selector: 'app-custom-outlet-grid',
  templateUrl: './custom-outlet-grid.component.html',
  styleUrls: ['./custom-outlet-grid.component.scss'],
  standalone: false
})
export class CustomOutletGridComponent implements OnInit {

  protected readonly PRODUCT_SCOPE = ProductScope.DETAILS;
  approvedProducts: Observable<Product>[] = [];

  constructor(
    protected componentData: CmsComponentData<CustomOutletGridData>,
    protected cmsService: CmsService,
    protected productService: ProductService,
    protected cd: ChangeDetectorRef,
  ) {
  }

  data$ = this.componentData.data$.pipe(map(component => component));

  productCodes$: Observable<string[]> = this.data$.pipe(
    map(products => [
      products.product1, products.product2, products.product3, products.product4,
      products.product5, products.product6, products.product7, products.product8,
    ]),
  );

  products$: Observable<Observable<Product>[]> = this.productCodes$.pipe(
    map((codes) =>
      codes.map((code) => this.productService.get(code, this.PRODUCT_SCOPE)),
    ),
  );


  ngOnInit(): void {

  }

}
